<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="text--primary"
        small
        v-on="on"
      >
        {{ $t('Add Note') }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline primary darken-1 pa-2 pl-3"
        style="color: #ffffff"
      >
        {{ $t('New Note') }}
      </v-card-title>

      <v-divider/>

      <v-card-text>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-radio-group
              v-model="noteType"
              row
              class="justify-center"
            >
              <v-radio
                :disabled="!canAddSimpleNote"
                :label="$t('Simple')"
                value="simple"
                v-on="on"
              />
              <v-radio
                :disabled="!canAddLabeledNote"
                :label="$t('Labeled')"
                value="labeled"
                v-on="on"
              />
            </v-radio-group>
          </template>
          <span>
            {{ $t('You can either add only simple notes or labeled notes to item') }}
          </span>
        </v-tooltip>

        <v-flex v-if="noteType === 'simple'">
          <v-text-field
            v-model="simpleNote"
            :label="$t('Simple Note')"
          />
        </v-flex>

        <v-flex v-if="noteType === 'labeled'">
          <v-text-field
            v-model="note.label"
            :label="$t('Label')"
          />
          <v-combobox
            v-model="note.values"
            :label="$t('Values')"
            return-object
            multiple
            small-chips
            deletable-chips
            outline
            append-icon=""
          />
        </v-flex>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-btn
          color="secondary"
          flat
          @click="cancel"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          @click="add"
        >
          {{ $t('Add') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OrderDraftItemNote',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      noteType: 'simple',
      simpleNote: '',
      note: {
        label: '',
        values: []
      }
    }
  },
  computed: {
    canAddSimpleNote () {
      return Array.isArray(this.item.notes) || !this.item.notes
    },
    canAddLabeledNote () {
      if (Array.isArray(this.item.notes)) {
        return this.item.notes.length === 0
      }
      return !this.item.notes || typeof this.item.notes === 'object'
    }
  },
  watch: {
    dialog: function (value) {
      if (value) {
        this.noteType = this.canAddSimpleNote ? 'simple' : 'labeled'
      }
    }
  },
  methods: {
    cancel () {
      this.dialog = false
    },
    add () {
      if (this.noteType === 'simple' && this.canAddSimpleNote) {
        this.addSimple()
      }
      if (this.noteType === 'labeled' && this.canAddLabeledNote) {
        this.addLabeled()
      }
      this.simpleNote = ''
      this.note = {}
      this.dialog = false
    },
    addSimple () {
      if (!this.item.notes) {
        this.item.notes = []
      }
      this.item.notes = [...this.item.notes, ...[this.simpleNote]]
      this.$emit('note-added')
    },
    addLabeled () {
      if (!this.item.notes || Array.isArray(this.item.notes)) {
        this.item.notes = {}
      }
      let notes = { ...this.item.notes }
      notes[this.note.label] = this.note.values
      this.item.notes = notes
      this.$emit('note-added')
    }
  }
}
</script>
